// src/features/projects/projectsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils';

// Async thunks
export const fetchProjects = createAsyncThunk(
    'projects/fetchProjects',
    async () => {
        const response = await apiFetch('api/project');
        const data = await response.json();
        return data;
    }
);

export const fetchPublicProjects = createAsyncThunk(
    'projects/fetchPublicProjects',
    async () => {
        const response = await apiFetch('api/project/public');
        const data = await response.json();
        return data;
    }
);

export const fetchProjectInfo = createAsyncThunk(
    'projects/info',
    async (projectId) => {
        const response = await apiFetch(`api/project/${projectId}`);
        const data = await response.json();
        return data;
    }
);

//export const createProject = createAsyncThunk(
//    'projects/createProject',
//    async (newProject) => {
//        const response = await apiFetch('api/project', {
//            method: 'POST',
//            body: JSON.stringify(newProject),
//        });
//        const data = await response.json();
//        return data;
//    }
//);

export const deleteProject = createAsyncThunk(
    'projects/deleteProject',
    async (projectId) => {
        await apiFetch(`api/project/${projectId}`, { method: 'DELETE' });
        return projectId;
    }
);

export const archiveProject = createAsyncThunk(
    'projects/archiveProject',
    async (projectId) => {
        await apiFetch(`api/project/archive/${projectId}`, { method: 'POST' });
        return projectId;
    }
);

export const restoreProject = createAsyncThunk(
    'projects/restoreProject',
    async (projectId) => {
        await apiFetch(`api/project/restore/${projectId}`, { method: 'POST' });
        return projectId;
    }
);

// Slice
const projectsSlice = createSlice({
    name: 'projects',
    initialState: {
        projectInfo: {},
        projects: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch projects
            .addCase(fetchProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProjects.fulfilled, (state, action) => {
                state.projects = action.payload;
                state.loading = false;
            })
            .addCase(fetchProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchProjectInfo.pending, (state) => {
                state.loading = true;
                state.projectInfo = {};
                state.error = null;
            })
            .addCase(fetchProjectInfo.fulfilled, (state, action) => {
                state.projectInfo = action.payload;
                state.loading = false;
            })
            .addCase(fetchProjectInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchPublicProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPublicProjects.fulfilled, (state, action) => {
                state.projects = action.payload;
                state.loading = false;
            })
            .addCase(fetchPublicProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // Create project
            //.addCase(createProject.fulfilled, (state, action) => {
            //    state.projects.push(action.payload);
            //})
            // Delete project
            .addCase(deleteProject.fulfilled, (state, action) => {
                state.projects = state.projects.filter(p => p.ProjectId !== action.payload);
            })
            // Archive project
            .addCase(archiveProject.fulfilled, (state, action) => {
                const proj = state.projects.find(p => p.ProjectId === action.payload);
                if (proj) proj.Status = 'Archived';
            })
            // Restore project
            .addCase(restoreProject.fulfilled, (state, action) => {
                const proj = state.projects.find(p => p.ProjectId === action.payload);
                if (proj) proj.Status = 'Active';
            });
    },
});

export default projectsSlice.reducer;
